import { getAbTestVariantNew } from "services/new-ab-tests/new-ab-tests-service";
import { HOMEPAGE_HIDE_BASIC_AB_TEST, HOMEPAGE_PRODUCT_SOLUTIONS_AB_TEST } from "constants/new-ab-tests";
import { PLATFORM_HIDE_BASIC_COOKIE, PLATFORM_SHOW_SOLUTIONS_PRICING } from "constants/cookies";

export const shouldHideBasic = ({ abTests, forcePricing, cookies, hasStudentPlan }) => {
  if (hasStudentPlan) return true; // First we check if we're in student plan mode - in this mode we don't show the basic tier

  const { [PLATFORM_HIDE_BASIC_COOKIE]: platformCookieValue } = cookies || {}; // The visitor might have came from the platform before, so we check if we hide basic in the platform
  if (platformCookieValue) return platformCookieValue === "true";
  if (forcePricing === "without_basic") return true; // We want to test it by ourselves so we use force_pricing query param.

  return (
    getAbTestVariantNew(abTests, HOMEPAGE_HIDE_BASIC_AB_TEST.test_name) ===
    HOMEPAGE_HIDE_BASIC_AB_TEST.new_variation_name
  );
};

const PRODUCT_COUNTRIES_TEST = ["il", "us"];

export const shouldSeeProductsPricingPage = ({
  abTests,
  hasStudentPlan,
  clusterId,
  cookies,
  forcePricing,
  cloudfrontViewerCountry
}) => {
  if (forcePricing === "products") return true;
  if (hasStudentPlan || clusterId === "ngo") return false;

  const { [PLATFORM_SHOW_SOLUTIONS_PRICING]: platformCookieValue } = cookies || {}; // The visitor might have came from the platform before, so we check if we hide basic in the platform
  if (platformCookieValue) return platformCookieValue === "true";

  if (!PRODUCT_COUNTRIES_TEST.includes(cloudfrontViewerCountry?.toLowerCase())) return false;

  return (
    getAbTestVariantNew(abTests, HOMEPAGE_PRODUCT_SOLUTIONS_AB_TEST.test_name) ===
    HOMEPAGE_PRODUCT_SOLUTIONS_AB_TEST.new_variation_name
  );
};
